<script setup lang="ts">
const props = withDefaults(defineProps<{
    inputPlaceholder?: string;
}>(), {
    inputPlaceholder: 'Wyszukaj...'
});

const emit = defineEmits<{
    (e: 'onSearch'): void;
    (e: 'onResetSearch'): void;
    (e: 'onChange'): void;
}>();

const model: any = defineModel<any>();

const search = (): void =>
{
    emit('onSearch');
};

const resetSearch = (): void =>
{
    model.value.search = '';

    emit('onResetSearch');
};

watch([() => model.value.dateFromUtc, () => model.value.dateDueUtc], () =>
{
    emit('onChange');
});
</script>

<template>
    <div class="menu-filters">
        <div class="input">
            <i class="search fa-solid fa-magnifying-glass" />
            <input v-model="model.search" type="text" :placeholder="$t(`[[[${props.inputPlaceholder}]]]`)" class="form-control" @input="search">
            <i v-show="model.search.length > 0" class="clear fa-solid fa-circle-xmark text-danger pointer" @click="resetSearch" />
        </div>
        <div class="row mt-3 gx-2">
            <div class="col-6">
                <IdeoDatetime
                    v-model="model.dateFromUtc"
                    name="dateFromUtc"
                    type="datetime"
                    position="left"
                    :preview="false"
                    :teleport="true"
                    :placeholder="$t('[[[Data od]]]')"
                    :max-date="model.dateDueUtc"
                    :hide-input-icon="true"
                />
            </div>
            <div class="col-6">
                <IdeoDatetime
                    v-model="model.dateDueUtc"
                    name="dateDueUtc"
                    type="datetime"
                    position="left"
                    :preview="false"
                    :teleport="true"
                    :placeholder="$t('[[[Data do]]]')"
                    :min-date="model.dateFromUtc"
                    :hide-input-icon="true"
                />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
[data-bs-theme=dark] .menu-filters {
    .input {
        .form-control {
            background: unset;
        }
    }
}

.menu-filters {
    padding: 0 0.75rem;

    .input {
        position: relative;
        color: var(--bs-gray-600);
        font-size: 13px;

        i {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            display: flex;
            align-items: center;
            justify-content: center;

            &.search {
                left: 12px;
                color: var(--bs-body-color);
            }

            &.clear {
                right: 12px;
            }
        }

        .form-control {
            padding-left: 36px;
            font-size: 0.875rem;
            height: 38px;
            font-size: 0.813rem;
            background: var(--bs-gray-100);
            border-color: var(--bs-gray-300);

            input {
                height: 100%;
                padding-right: 38px;
            }
        }

        &-reverse {
            i {
                left: unset;
                right: 10px;
            }

            .form-control {
                padding-left: 0.75rem;
            }
        }
    }

    :deep(.dp__input) {
        padding-left: 4px;
        padding-right: 18px;
    }

    :deep(.dp__clear_icon) {
        padding-left: 3px;
        padding-right: 5px;
    }
}
</style>
